module.exports = __webpack_public_path__ + "ae1f7e782ac2374e766a78facfa3e44a.svg";